/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { buildDispatchable } from '../../actions/_action-utilities';
import history from '../../history';
import { groupActions } from '../../actions/groups';
import { Groups } from './groups';
import { commonEnums } from '@codametrix/ui-common';
import { isResourceViewOnly } from '../../core/resources';
const { ResourceId } = commonEnums;
export const mapStateToProps = function(state) {
    const { group, ui, organization } = state;
    const viewOnly = isResourceViewOnly(ui.context.activeContext?.resources || [], ResourceId.GROUPS);
    return {
        ...group,
        sortablePageable: group.groupsList.sortablePageable,
        viewOnly,
        selectedOrg: organization.activeOrganization
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        onSelection: (item)=>{
            runDispatchable(()=>{
                if (item.data.id) {
                    return dispatch(groupActions.getGroupDetail(item));
                }
            });
        },
        list: (listParams)=>{
            runDispatchable(()=>{
                return dispatch(groupActions.listItems(listParams));
            });
        },
        navigate: (path)=>{
            runDispatchable(()=>{
                history.push(path);
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Groups);
